/** A list's `sort` (`field` or `-field`) as its field and direction. */
export function parseSort(sort: string): { field: string; desc: boolean } {
  return sort.startsWith('-') ? { field: sort.slice(1), desc: true } : { field: sort, desc: false }
}
